var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({on:{"blur":_vm.blur}},'v-text-field',{
        value: _vm.value,
        type: 'url',
        dense: true,
        outlined: true,
        'hide-details': 'auto',
        placeholder: 'https://...',
        clearable: true,
        ..._vm.$attrs,
    },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }